/* vvd-custom-qty.js — BUG-496 (23 Sep 2026)
   Custom quantity on the buy-cards widget ("Or enter exact quantity"):
   1. price appears while the customer types (was: only on blur, and on tiered products a "—");
   2. the chosen quantity is written to BOTH #hidden_qty and every input[name="quantity"].
   Prices are NOT calculated here. The per-unit price for a quantity is read from the widget's own
   quantity tiles, which vv-buy-cards.js fills from the ITORIS tier prices (.itier_price) or the
   product's tier metafield; the tile for the largest break <= qty gives the unit price, exactly as
   the ITORIS tier table does. The widget's own syncTotal() does the display.
   On DPO products vv-buy-cards.js already defines window.__vvbcPriceFor; it is left untouched. */
(function () {
  if (window.__vvdCustomQty) return;
  window.__vvdCustomQty = 1;

  function wrapEl() { return document.querySelector('.vvbc'); }
  function exactInput() { return document.querySelector('.vvbc .vvbc-exact input'); }

  // Unit prices as rendered on the widget's tiles: [{q, u}] sorted by q.
  function tileLadder() {
    var out = [];
    [].forEach.call(document.querySelectorAll('.vvbc .vvbc-qty .vvbc-qtile'), function (t) {
      var q = parseInt(((t.querySelector('b') || {}).textContent || ''), 10);
      if (!(q > 0)) return;
      var qs = (t.querySelector('.vvbc-qs') || {}).textContent || '';
      var qp = (t.querySelector('.vvbc-qp') || {}).textContent || '';
      var m = qs.match(/\$\s*([\d,]+(?:\.\d+)?)\s*ea/i), u = NaN;
      if (m) u = parseFloat(m[1].replace(/,/g, ''));
      else if (q === 1 && qp) u = parseFloat(qp.replace(/[^0-9.]/g, ''));
      if (u > 0) out.push({ q: q, u: u });
    });
    return out.sort(function (a, b) { return a.q - b.q; });
  }

  function installPriceFor() {
    if (typeof window.__vvbcPriceFor === 'function') return; // DPO path: widget's own lookup
    window.__vvbcPriceFor = function (n) {
      var L = tileLadder();
      if (!L.length || !(n > 0)) return null;
      var u = null;
      for (var i = 0; i < L.length; i++) if (L[i].q <= n) u = L[i].u;
      return u;
    };
    window.__vvbcPriceFor.__vvd = 1;
  }

  function desiredQty() {
    var w = wrapEl(); if (!w) return null;
    var ex = exactInput(), on = w.querySelector('.vvbc-qtile.on b');
    if (ex && ex.value !== '' && !on) { var n = parseInt(ex.value, 10); if (n > 0) return n; }
    if (on) { var m = parseInt(on.textContent, 10); if (m > 0) return m; }
    var g = parseInt(window.__vvbcQty, 10);
    return g > 0 ? g : null;
  }

  // Write the quantity to #hidden_qty and every Shopify quantity input.
  function writeQty(n) {
    if (!(n > 0)) return;
    var h = document.getElementById('hidden_qty');
    if (h && String(h.value) !== String(n)) h.value = n;
    [].forEach.call(document.querySelectorAll('input[name="quantity"]'), function (q) {
      if (String(q.value) === String(n)) return;
      q.value = n;
      ['input', 'change'].forEach(function (ev) { q.dispatchEvent(new Event(ev, { bubbles: true })); });
    });
  }
  window.__vvdSyncQty = function () { writeQty(desiredQty()); };

  var tmr = null;
  function onType() {
    clearTimeout(tmr);
    tmr = setTimeout(function () {
      var ex = exactInput(); if (!ex) return;
      var n = parseInt(ex.value, 10);
      if (!(n > 0)) return;
      // hand over to the widget's own change handler (propagates qty to the ITORIS/legacy inputs and
      // re-renders the total), then make sure both quantity fields hold the same number.
      ex.dispatchEvent(new Event('change', { bubbles: true }));
      setTimeout(function () {
        writeQty(n);
        window.__vvbcSyncTotal && window.__vvbcSyncTotal();
      }, 300);
    }, 350);
  }

  function bind() {
    var ex = exactInput();
    if (!ex || ex.__vvdBound) return !!ex;
    ex.__vvdBound = 1;
    installPriceFor();
    ex.setAttribute('inputmode', 'numeric');
    ex.addEventListener('input', onType);
    ex.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); onType(); } });
    ex.addEventListener('change', function () { setTimeout(window.__vvdSyncQty, 300); });
    var w = wrapEl();
    // tile picks: widget updates the Shopify input; keep #hidden_qty in step
    w.addEventListener('click', function (e) {
      if (e.target.closest('.vvbc-qtile')) setTimeout(window.__vvdSyncQty, 300);
    });
    // right before any add-to-cart path, make sure both fields hold the chosen quantity
    document.addEventListener('click', function (e) {
      if (e.target.closest('.vvbc-cta--own,[data-opt="expert"],#skip_upload,#continue_cart,#quote_to_cart_btn,#AddToCart,button[name="add"]')) window.__vvdSyncQty();
    }, true);
    return true;
  }

  var tries = 0, iv = setInterval(function () {
    if (bind() || ++tries > 120) clearInterval(iv);
  }, 250);
})();
